import React, { useCallback, useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { getCandidateInfoOLD } from 'requests/APIrequests';
import {
    getAuditionQuestionResults, getCandidateAudition,
    getCandidatePosts, getEmployerGradeQuestion,
    gradeEmployerAnswer, addCandidateComment,
    getAuditionScreeningQuestionResults
} from 'requests/JobOpportunityRequests';
import { getCompanyTags } from 'requests/SettingsRequests';
import CandidateCardWrapper from 'components/candidate_cards/CandidateCardWrapper';
import { observer } from 'mobx-react-lite';
import * as qs from 'query-string';
import AuditionListSelect from '../CandidateCardWrapper/AuditionListSelect';

const EmployerCardContent = observer(({
    match, opportunitiesList, onLoadCandidate,
    company, userId: userIdProp, context, location,
    opportunitySlug: opportunitySlugProps,
    onHireChanges, removeCandidateTab, getOpportunitiesList
}) => {
    const [user, setUser] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [selectedOpportunityIndex, setSelectedOpportunityIndex] = useState(0);
    const [selectedAuditionIndex, setSelectedAuditionIndex] = useState(0);
    const [isLoadingAudition, setLoadingAudition] = useState(false);
    const [isRestoreLoading, setIsRestoreLoading] = useState(false);
    const [companyTags, setCompanyTags] = useState([]);
    const selectionRef = useRef(null);
    const preserveNextSelectionRef = useRef(false);

    const { user_id } = match.params;
    const userId = user_id || userIdProp;

    const parsed = qs.parse(location.search);
    const { assessment: assessmentSlug, opportunity: opportunityParsed } = parsed;
    const opportunitySlug = opportunitySlugProps || opportunityParsed;

    useEffect(() => {
        setLoading(true);
        getUserInfo();
        getTags();
    }, [userId]);

    useEffect(() => {
        if (!opportunitiesList.length) {
            if (!preserveNextSelectionRef.current) {
                setSelectedOpportunityIndex(0);
                setSelectedAuditionIndex(0);
            }
            return;
        }
        setInitialIndexes();
    }, [opportunitiesList]);

    const setSelectedIndexes = (opportunityIndex = selectedOpportunityIndex, assessmentIndex = selectedAuditionIndex) => {
        if (!opportunitiesList || !opportunitiesList[opportunityIndex]) return;

        setSelectedOpportunityIndex(opportunityIndex);
        setSelectedAuditionIndex(assessmentIndex);

        const col = opportunitiesList[opportunityIndex].columns[assessmentIndex];
        if (col) {
            selectionRef.current = col.audition.opportunitySlug;
            setLoadingAudition(true);
            getCandidateAudition(col.userAudition.uuid)
                .then(({ success, data }) => {
                    if (success && data) {
                        setUser(prev => ({ ...prev, ...data }));
                    }
                })
                .finally(() => {
                    setLoadingAudition(false);
                });
        }
    };

    const refreshOpportunities = useCallback(async (...args) => {
        setIsRestoreLoading(true);
        preserveNextSelectionRef.current = true;
        await getOpportunitiesList?.(...args);
        setIsRestoreLoading(false);
    }, [getOpportunitiesList]);

    const tryRestoreSelection = () => {
        const selectedSlug = selectionRef.current || null;
        let opportunityIndex = 0;
        let columnIndex = 0;
        let found = false;

        if (selectedSlug) {
            const i = opportunitiesList.findIndex(o => o?.opportunity?.slug === selectedSlug);
            if (i !== -1) {
                const cols = opportunitiesList[i]?.columns || [];
                const j = cols.findIndex(c => c.audition.opportunitySlug === selectedSlug);

                if (j !== -1) {
                    opportunityIndex = i;
                    columnIndex = j;
                    found = true;
                }
            }
        }

        if (found) {
            setSelectedIndexes(opportunityIndex, columnIndex);
            return true;
        }
        return false;
    };

    const setInitialIndexes = () => {
        if (preserveNextSelectionRef.current) {
            preserveNextSelectionRef.current = false;
            if (tryRestoreSelection()) return;
        }

        let opportunityIndex = 0;
        let columnIndex = 0;
        if (opportunitySlug) {
            const oppIndex = opportunitiesList.findIndex(({ opportunity: { slug } }) => slug === opportunitySlug);
            if (oppIndex !== -1) opportunityIndex = oppIndex;
            if (assessmentSlug && opportunityIndex !== -1) {
                const index = opportunitiesList[opportunityIndex].columns.findIndex(({ audition }) => audition.slug === assessmentSlug);
                if (index !== -1) columnIndex = index;
            }
        } else if (assessmentSlug) {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < opportunitiesList.length; i++) {
                const index = opportunitiesList[i].columns.findIndex(({ audition }) => audition.slug === assessmentSlug);
                if (index !== -1) {
                    columnIndex = index;
                    opportunityIndex = i;
                    break;
                }
            }
        }
        setSelectedIndexes(opportunityIndex, columnIndex);
    };

    const getTags = () => {
        getCompanyTags()
            .then(({ success, data }) => {
                if (success && data) {
                    setCompanyTags(data);
                }
            });
    };

    const getUserInfo = () => {
        getCandidateInfoOLD(userId, false)
            .then((response) => {
                const { success, candidate } = response;
                if (success && candidate) {
                    setUser(candidate);
                    if (onLoadCandidate) {
                        onLoadCandidate(candidate)
                            .finally(() => {
                                setLoading(false);
                            });
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                if (removeCandidateTab) removeCandidateTab(userId);
            });
    };

    let selectedAudition = {};
    let returnedOpportunitySlug = opportunitySlug;
    if (opportunitiesList.length && opportunitiesList[selectedOpportunityIndex] && opportunitiesList[selectedOpportunityIndex].columns[selectedAuditionIndex]) {
        selectedAudition = opportunitiesList[selectedOpportunityIndex].columns[selectedAuditionIndex].audition;
        returnedOpportunitySlug = selectedAudition.opportunitySlug;
    }

    return (
        <CandidateCardWrapper
            user={user}
            context={context}
            setUser={setUser}
            company={company}
            isLoading={isLoading}
            getTags={getTags}
            setTags={setCompanyTags}
            getUserInfo={() => setSelectedIndexes()}
            opportunitySlug={returnedOpportunitySlug}
            audition={selectedAudition}
            isLoadingAudition={isLoadingAudition}
            loadCandidatePosts={getCandidatePosts}
            addCandidateComment={addCandidateComment}
            loadGradeQuestion={getEmployerGradeQuestion}
            getAuditionQuestionResults={getAuditionQuestionResults}
            getAuditionScreeningQuestionResults={getAuditionScreeningQuestionResults}
            gradeFunction={gradeEmployerAnswer}
            companyTags={companyTags}
            onHireChanges={onHireChanges}
            refreshOpportunities={refreshOpportunities}
            isRestoreLoading={isRestoreLoading}
            ReportHeaderComp={(
                <AuditionListSelect
                    opportunitiesList={opportunitiesList}
                    selectedOpportunityIndex={selectedOpportunityIndex}
                    selectedAuditionIndex={selectedAuditionIndex}
                    setSelectedIndexes={setSelectedIndexes}
                    isLoadingAudition={isLoadingAudition}
                />
            )}
            onDeleteCallback={getUserInfo}
        />
    );
});

export default withRouter(EmployerCardContent);
